// src/components/layout/Sidebar.tsx

import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { logout } from "../../store/slices/authSlice";
import { fullName } from "../../utils/format";
import logoLight from "../../assets/images/logo-toinup-horizontal-light.svg";
import logoSquareLight from "../../assets/images/logo-toinup-square-light.svg";

interface Props {
  collapsed: boolean;
  mobileOpen: boolean;
  onToggle: () => void;
  onMobileClose: () => void;
}

interface NavItem {
  to: string;
  icon: string;
  label: string;
}

const navItems: NavItem[] = [
  { to: "/dashboard", icon: "bi-grid-1x2-fill", label: "Dashboard" },
  { to: "/usuarios", icon: "bi-people-fill", label: "Usuarios" },
  { to: "/cupones", icon: "bi-ticket-perforated-fill", label: "Cupones" },
];

export default function Sidebar({ collapsed, mobileOpen, onToggle, onMobileClose }: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <>
      {/* Backdrop móvil */}
      <div
        className="sidebar-backdrop"
        style={{ display: mobileOpen ? "block" : "none" }}
        onClick={onMobileClose}
      />

      <aside className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobile-open" : ""}`}>
        {/* Header */}
        <div className="sidebar-header">
          {!collapsed && (
            <div className="sidebar-logo">
              <img src={logoLight} alt="Toinup" style={{ height: 36, width: "auto", display: "block" }} />
            </div>
          )}
          <button
            className="sidebar-toggle d-none d-lg-flex"
            onClick={onToggle}
            title={collapsed ? "Expandir menú" : "Colapsar menú"}
          >
            {collapsed ? (
              <img src={logoSquareLight} alt="Toinup" style={{ height: 34, width: "auto" }} />
            ) : (
              <i className="bi bi-layout-sidebar-inset-reverse" style={{ fontSize: "1.2rem" }} />
            )}
          </button>
          <button className="sidebar-toggle d-lg-none" onClick={onMobileClose} title="Cerrar menú">
            <i className="bi bi-x-lg" style={{ fontSize: "1.1rem" }} />
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {!collapsed && <div className="sidebar-section-title">MENÚ PRINCIPAL</div>}

          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""}`}
              onClick={onMobileClose}
              title={collapsed ? item.label : undefined}
            >
              <i className={`bi ${item.icon}`} />
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* Footer con usuario */}
        <div className="sidebar-footer">
          {!collapsed && user && (
            <div style={{ marginBottom: 12, overflow: "hidden" }}>
              <div
                style={{
                  fontSize: "0.8rem",
                  color: "rgba(255,255,255,0.9)",
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {fullName(user.firstName, user.lastName, user.username)}
              </div>
              <div
                style={{
                  fontSize: "0.72rem",
                  color: "rgba(255,255,255,0.5)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {user.email}
              </div>
            </div>
          )}
          <button
            className="sidebar-item"
            onClick={handleLogout}
            style={{ color: "rgba(255,140,160,0.95)", padding: collapsed ? "11px 0" : undefined, justifyContent: collapsed ? "center" : undefined }}
            title={collapsed ? "Cerrar sesión" : undefined}
          >
            <i className="bi bi-box-arrow-right" />
            {!collapsed && <span>Cerrar sesión</span>}
          </button>
        </div>
      </aside>
    </>
  );
}
